import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core'

import { IStyle } from '../../../Interface/style'

@Component({
  selector: 'bmcore-genre-category',
  templateUrl: './bmcore-genre-category.component.html',
  styleUrls: ['./bmcore-genre-category.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class BmcoreGenreCategoryComponent implements OnInit {
  @Input() genre: IStyle

  path = 'assets/images/styles-categories/'

  constructor() {}

  ngOnInit(): void {}

  getCover(title: string): string {
    // 1. To lowercase
    const lowercaseTitle = title.toLowerCase()
    // 2. Delete backslash
    const titleWithoutBackslash = lowercaseTitle.replace(/\//g, '')
    // 3. First word
    const result = titleWithoutBackslash.split(' ')[0]

    return `${this.path + result}.webp`
  }
}
